export default __webpack_public_path__ + "static/media/7.bcdfa23a.jpg";